<template>
  <div class="cards">
    <div class="card-img">
      <img src="../../assets/icone-lugar.svg" alt="" />
    </div>

    <div class="card-address">
      <div>
        <p class="place">
          {{ address.data.logradouro ? address.data.logradouro : "N/A" }}
        </p>
        <p class="city">
          {{ address.data.localidade ? address.data.localidade : "N/A" }} -
          {{ address.data.uf ? address.data.uf : "N/A" }}
        </p>
      </div>

      <div class="card-zipcode">
        <p>{{ address.data.cep ? address.data.cep : "N/A" }}</p>
      </div>
    </div>

    <div class="divider"></div>
    <div class="card-remove">
      <div class="card-remove-img">
        <img
          @click="remove(address.id)"
          src="../../assets/icone-lixo.svg"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
    },
  },
  methods: {
    remove(id) {
      this.$emit('remove', id);
    },
  },
};
</script>

<style>
@import url("./style.scss");
</style>
